import { Loading } from '@linktivity/link-ui';
import styles from './loader.module.css';

const Loader = ({ className = '' }) => {
  return (
    <div className={`${styles.loader} ${className}`}>
      <Loading />
    </div>
  );
};
export default Loader;
